var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarWithCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 80,
    viewBox: "0 0 99 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5768 23.6336C11.6284 23.3709 11.8588 23.1814 12.1265 23.1814L77.098 23.1814C77.4508 23.1814 77.7158 23.5035 77.6478 23.8497L66.8024 79.0377C66.7508 79.3004 66.5204 79.4899 66.2526 79.4899H1.6217C1.0925 79.4899 0.694997 79.0067 0.797042 78.4875L11.5768 23.6336Z",
    fill: "#4793F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6406 23.7128C11.6606 23.404 11.9167 23.1814 12.2261 23.1814H77.1435C77.4809 23.1814 77.7418 23.4775 77.6993 23.8122L70.6979 79.0002C70.6624 79.2801 70.4651 79.4899 70.1829 79.4899C64.9596 79.4899 16.0921 79.4899 4.21189 79.4899C3.20122 79.4899 2.56356 78.3811 2.93554 77.4413C7.69565 65.4161 11.3068 28.8676 11.6406 23.7128Z",
    fill: "#A8CCF8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6621 23.6649C11.6871 23.3753 11.9271 23.1814 12.2177 23.1814H77.1859C77.5079 23.1814 77.7636 23.4522 77.7453 23.7737L74.5877 78.9627C74.5707 79.2588 74.3673 79.4903 74.0707 79.4909C68.0732 79.5027 8.65918 79.6179 7.76025 79.5583C6.86511 79.499 11.1883 29.152 11.6621 23.6649Z",
    fill: "#648CFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6518 23.7037C11.6597 23.4004 11.9073 23.1814 12.2107 23.1814H77.234C77.5375 23.1814 77.7858 23.423 77.7941 23.7264L79.3042 78.9143C79.3128 79.2296 79.091 79.4899 78.7755 79.4899C72.612 79.4899 16.1356 79.4899 13.2064 79.4899C10.2836 79.4899 11.504 29.3845 11.6518 23.7037Z",
    fill: "#2538BF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7241 23.8015C11.693 23.4728 11.9509 23.1814 12.2811 23.1814H77.226C77.5326 23.1814 77.7824 23.4192 77.7877 23.7258C77.8748 28.7125 78.7054 66.5107 84.0049 76.8794C84.1851 77.2319 83.9957 77.6548 83.6035 77.7087C72.7503 79.2012 28.1016 79.46 22.3597 79.4873C21.9949 79.489 21.6728 79.2518 21.5605 78.9048C16.2103 62.368 14.1652 49.6099 11.7241 23.8015Z",
    fill: "#A8CCF8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7176 23.7894C11.6896 23.4624 11.9476 23.1814 12.2758 23.1814H77.2362C77.5388 23.1814 77.7867 23.4216 77.7962 23.724L78.0897 33.0225L12.4698 32.5831L11.7176 23.7894Z",
    fill: "#4793F1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1314 38.6754H69.779L70.7565 44.323H65.1089L64.1314 38.6754Z",
    fill: "#648CFE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1395 38.6754H59.7871L60.7645 44.323H55.1169L54.1395 38.6754Z",
    fill: "#648CFE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1475 38.6754H49.7951L50.7726 44.323H45.125L44.1475 38.6754Z",
    fill: "#648CFE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M65.869 47.1469H71.5166L72.494 52.7945H66.8464L65.869 47.1469Z",
    fill: "#648CFE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8769 47.1469H61.5245L62.502 52.7945H56.8544L55.8769 47.1469Z",
    fill: "#648CFE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8849 47.1469H51.5326L52.51 52.7945H46.8624L45.8849 47.1469Z",
    fill: "#E7F1FD"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8931 47.1469H41.5407L42.5182 52.7945H36.8706L35.8931 47.1469Z",
    fill: "#E7F1FD"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9012 47.1467H31.5488L32.5263 52.7943H26.8787L25.9012 47.1467Z",
    fill: "#E7F1FD"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3895 56.2697H73.0371L74.0145 61.9173H68.3669L67.3895 56.2697Z",
    fill: "#648CFE"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3974 56.2697H63.045L64.0225 61.9173H58.3749L57.3974 56.2697Z",
    fill: "#648CFE"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4056 56.2697H53.0532L54.0307 61.9173H48.383L47.4056 56.2697Z",
    fill: "#648CFE"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4135 56.2697H43.0611L44.0386 61.9173H38.391L37.4135 56.2697Z",
    fill: "#FFBF39"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4218 56.2697H33.0694L34.0469 61.9173H28.3993L27.4218 56.2697Z",
    fill: "#648CFE"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1352 65.3929H64.7828L65.7603 71.0405H60.1127L59.1352 65.3929Z",
    fill: "#648CFE"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1434 65.3929H54.791L55.7684 71.0405H50.1208L49.1434 65.3929Z",
    fill: "#648CFE"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1514 65.3929H44.799L45.7765 71.0405H40.1289L39.1514 65.3929Z",
    fill: "#E7F1FD"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1595 65.3928H34.8071L35.7846 71.0404H30.137L29.1595 65.3928Z",
    fill: "#E7F1FD"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.4881 43.5694C98.5082 36.8383 101.985 22.448 95.254 11.4279C88.5229 0.407756 74.1326 -3.06917 63.1125 3.66198C56.1316 7.9259 52.1777 15.2632 51.928 22.8704L47.6705 40.4912L65.2877 44.7478C72.1705 48.0011 80.5057 47.8343 87.4881 43.5694Z",
    fill: "#66CC84"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.4444 34.7489C68.9915 34.8709 63.6615 29.7388 63.5394 23.286C63.4174 16.8331 68.5495 11.5031 75.0023 11.381C81.4552 11.2589 86.7852 16.391 86.9073 22.8439C87.0294 29.2968 81.8972 34.6268 75.4444 34.7489ZM61.4776 23.325C61.3339 15.7334 67.3717 9.46274 74.9633 9.31913C82.5549 9.17552 88.8255 15.2133 88.9692 22.8049C89.1128 30.3965 83.075 36.6671 75.4834 36.8107C67.8918 36.9543 61.6212 30.9166 61.4776 23.325ZM81.0557 20.2461C81.4507 19.8359 81.4383 19.1832 81.0281 18.7882C80.6179 18.3932 79.9651 18.4055 79.5702 18.8158L73.5425 25.0759L70.7838 22.4196C70.3736 22.0247 69.7208 22.037 69.3258 22.4472C68.9308 22.8575 68.9432 23.5102 69.3534 23.9052L72.8548 27.2766C73.2651 27.6716 73.9178 27.6593 74.3128 27.2491L81.0557 20.2461Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarWithCheckmark);
export default __webpack_public_path__ + "static/media/calendar-with-checkmark.1375347eaf52f25cc4067607c6881e10.svg";
export { ForwardRef as ReactComponent };